import { useState } from "react";
import { Link } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { TOOL_CRISIS } from "@/data/tools";
import { rememberSource, track } from "@/lib/toolTrack";
import { ToolShare } from "@/components/tools/ToolShare";

const FEELINGS = {
  calmer: ["😌", "Calmer", "That's your nervous system settling. You did that, and you can come back to it any time."],
  same: ["🙂", "About the same", "That's okay. Some moments need more than one try. Every pause is practice that adds up."],
  tense: ["😣", "Still tense", "Thank you for being honest. Tension can take a while to ease, and you don't have to sort it out alone."],
};

export const ToolCrisis = () => <p className="mm-soft rounded-2xl p-4 mt-4 text-sm" data-testid="tool-crisis">{TOOL_CRISIS} <a href="tel:988" className="font-semibold text-mm-primary">Call 988</a></p>;

export const ToolInvite = ({ tool, onAgain, card }) => (
  <>
    <p className="text-mm-muted mt-5">Mindful Me has 100+ tools like this, plus a personal playbook that learns what helps you.</p>
    <div className="flex flex-wrap gap-2 mt-4">
      <Link to="/pricing" onClick={() => { track(tool.slug, "pricing"); rememberSource(tool.slug); }} className="mm-btn" data-testid="tool-see-pricing">See pricing</Link>
      {onAgain && <button onClick={onAgain} className="mm-btn-ghost" data-testid="tool-again"><RotateCcw size={16} />Again</button>}
      <Link to="/tools" className="mm-btn-ghost" data-testid="tool-try-another">Try another tool</Link>
    </div>
    <div className="mt-4"><ToolShare tool={tool} card={card} /></div>
  </>
);

export const ToolFinish = ({ tool, onAgain }) => {
  const [feel, setFeel] = useState(null);
  const pick = (k) => { setFeel(k); track(tool.slug, `feel_${k}`); };
  const card = { line: `I just took ${tool.mins} to breathe 🌿`, sub: `${tool.name}. Try it free.`, emoji: tool.emoji };
  if (!feel) return (
    <div className="text-center" data-testid="tool-feedback">
      <p className="text-xl font-bold">How do you feel now?</p>
      <div className="flex flex-wrap justify-center gap-2 mt-4">
        {Object.entries(FEELINGS).map(([k, [e, l]]) => <button key={k} onClick={() => pick(k)} className="mm-chip !py-2.5 !px-4" data-testid={`tool-feel-${k}`}>{e} {l}</button>)}
      </div>
    </div>
  );
  return (
    <div className="mm-fade-up" data-testid="tool-reply">
      <p className="text-lg" data-testid="tool-reply-text">{FEELINGS[feel][2]}</p>
      {feel === "tense" && <><Link to="/wellbeing-check" className="inline-block mt-3 font-semibold text-mm-primary">Take the free wellbeing check →</Link><ToolCrisis /></>}
      <ToolInvite tool={tool} onAgain={onAgain} card={card} />
    </div>
  );
};
